import React from "react";
import { useSelector } from "react-redux";
import ImageGalleryTabComponent from "./imageGalleryTab.component";

export default function ImageGalleryTabContainer(props) {
  const lang = useSelector(state => state.constant.languages);
  return <ImageGalleryTabComponent {...props} lang={lang}/>;
}
